import React from 'react'
import { Text } from '@/components/atoms/Text'
import './ServiceCard.css'

export interface ServiceCardProps {
  title: string
  description: string
  services: string[]
  imageUrl?: string
  imageAlt?: string
  stepNumber?: string
  className?: string
}

export const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  services,
  imageUrl,
  imageAlt,
  stepNumber,
  className = '',
}) => {
  return (
    <article className={`service-card ${className}`}>
      <div className="service-card-content">
        {stepNumber && (
          <Text size="small" color="gray" weight="medium" className="service-card-step-number">
            {stepNumber}
          </Text>
        )}
        <Text size="large" color="primary" weight="bold" className="service-card-title">
          {title}
        </Text>
        <Text size="large" color="gray" weight="normal" className="service-card-description">
          {description}
        </Text>
        <div className="service-card-services">
          {services.map((service, index) => (
            <Text
              key={index}
              size="base"
              color="primary"
              weight="medium"
              className="service-card-service-item"
            >
              {service}
            </Text>
          ))}
        </div>
      </div>
      <div className="service-card-image-container">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={imageAlt || `${title} illustration`}
            className="service-card-image"
          />
        ) : (
          <div className="service-card-image-placeholder">
            <span className="service-card-image-placeholder-text">Image Placeholder</span>
          </div>
        )}
      </div>
    </article>
  )
}
